<template>
  <div class="promotion-wrap" :class="{'pc-wrap': channel === '1'}">
    <navbar :title="title" :shareInfo="share" :isTujiaHarmony="isTujiaHarmony" :tujiaHarmonyStatusBarHeight="tujiaHarmonyStyle.top" :goToCtripListPage="goToCtripListPage" :houseInfo="houseInfo"/>
    <pc-header v-if="channel === '1' && !$root.isMayi" />
    <component :is="comp.compName" :compProps="comp" :compIndex="`${index}`" v-for="(comp, index) in children" :key="comp.elementId" :isTujiaHarmony="isTujiaHarmony" :tujiaHarmonyStatusBarHeight="tujiaHarmonyStyle.top" @reload="initPromotion"></component>
    <top-btn :entryInfo="entryInfo"></top-btn>
    <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
    <rules v-if="showRules" :rules="rules" @action="rulesHandle"></rules>
    <rules-btn v-if="rulesImg" :rulesImg="rulesImg" :rulePlacement="rulePlacement" :isTujiaHarmony="isTujiaHarmony" :tujiaHarmonyStatusBarHeight="tujiaHarmonyStyle.top" @action="rulesHandle"></rules-btn>
    <order-atmosphere v-if="needShowOrder" :channel="channel" :defaultTop="rulesImg ? 42:10" :compProps="atmosphereConfig" />
    <transition enter-active-class="animated">
      <div class="tabPage" v-if="isSharePhotoShow" @click.stop="sharePhotoHide">
        <img :src="base64" alt />
      </div>
    </transition>
    <canvas ref="canvas" id="canvas" v-show="false">您的浏览器暂不支持绘图功能</canvas>
    <div v-if="isLoading" class="common-loading">
      <tj-loading :size="'100px'" type="pointloading" />
    </div>
    <outcode-backbtn />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import elements from './uiComps'
import TopBtn from '@/components/TopBtn'
import Toast from '@/components/Toast'
import Rules from '@/components/Rules'
import RulesBtn from '@/components/RulesBtn'
import pcHeader from '@/components/PcActivityHeader'
import OrderAtmosphere from '@/components/OrderAtmosphere'
import navbar from '@/components/Navbar'
import { QConfig, Sniff } from '@/utils/q_sniff'
import { qunarHook, checkUser } from '@/utils/q_hook'
import '@/styles/quill.core.css'
import '@/styles/quill.snow.css'
import { getPromotionDetailForMayi, getPromotionPreviewForMayi, getPromotionDetail, getPromotionPreview, getUserInfoForMayi, getPromotionDetailForQ, getHouseGroup } from '@/services/promotion'
import { getFromForLog, getSession, sessionKeys } from '@/utils/q_business'
import { errorReport, getExclusiveHouse } from '@/utils/index.js'
// import { autoReport } from '@/utils/report.js'
// import { qunarAutoReport } from '@/utils/q_report.js'
import { recordPv } from '@/utils/q_log'
import urlHelper from '@lib/utils/urlHelper'
import '@tujia/fe_bridge'
import Cookies from 'js-cookie'
import tjAppHelper from '@lib/business/tjAppHelper'
import tujialogin from '@/utils/tujialogin.js'
import callApp from '@lib/utils/callApp.js'
import { getPlatform } from '@common-libs/tj-utils/platform'
import { Toast as ToastUI } from '@tujia/tj-mob-ui'
import experienceMemberAPI from '@/services/experienceMember'
import { receiveExMemberForQ } from '@/services/q_experienceMember'
import redBookiApi from '@/services/redBook'
import { getClientId } from '@/utils/deviceInfo'
import { loginQ } from '@/utils/q_userinfo'
import tjCookie from '@/utils/tjCookie'
import { initPageShare } from '@/components/sharePopup'
import commonApi from '@/services/commonApi'
import OutCodeBackBtn from '@/components/OutCodeBackBtn'
import { getAppInfo, getHarmonyOSImmersive } from '@/utils/t_harmony_os_header_info'
import { fetchHouseDetail } from '@/services/list'

const isQunarApp = getPlatform().isQunarAppEnv

export default {
  mixins: [tujialogin],
  components: {
    ...elements,
    navbar: navbar,
    'top-btn': TopBtn,
    'order-atmosphere': OrderAtmosphere,
    Toast,
    Rules,
    'rules-btn': RulesBtn,
    'pc-header': pcHeader,
    'outcode-backbtn': OutCodeBackBtn
  },
  computed: {
    ...mapState(['userInfo']),
    /**
     * 途家客户端
     */
    tujiaAppCpd() {
      return process.env.VUE_APP_LOCAL === 'T' && this.platformEnv.isTujiaAppEnv
    },
    /**
     * 是否从登陆页返回
     * @param {int} id 红包id
     */
    isFromLoginPage() {
      return window.localStorage.getItem('isFromLoginPage') && window.localStorage.getItem('isFromLoginPage') === '1'
    },
    isActiveFission() {
      return ['T20230310142815', 'T20230310191107', 'Q20230310140905'].indexOf(this.$route.query.id) > -1
    },
    goToCtripListPage() {
      return ['T20250210100350', 'T20250704144806'].indexOf(this.$route.query.id) > -1
    },
    isSharedPeople() { // 被分享者
      if (process.env.VUE_APP_LOCAL !== 'Q') {
        if (this.fId && this.fId !== Number(tjCookie.getUserId())) {
          return true
        } else {
          return false
        }
      } else {
        if (Sniff.uinfo && this.fId && this.fId !== Sniff.uinfo.uid) {
          return true
        } else {
          return false
        }
      }
    }
  },
  data() {
    return {
      houseInfo: null, // 根据路由房屋 ID 获取的房屋信息
      promotion: null, // 活动信息，转换成对象后的数据
      children: [], // 页面的组件元素
      entryInfo: {}, // 活动浮层信息
      share: {}, // 分享信息
      // 防止重复点击收藏
      isClick: false,
      msg: '', // toast 信息
      showToast: false, // toast控制
      channel: '2', // 渠道 h5 还是 app/小程序
      title: '', // 去哪儿页面头部标题
      showRules: false, // 控制活动规则
      rules: {}, // 活动规则信息
      rulesImg: '', // 活动规则按钮图标
      rulePlacement: '', // 活动规则按钮位置
      needShowOrder: false, // 是否需要展示订单氛围
      atmosphereConfig: {}, // 订单氛围的背景色等
      // 低于7.2的版本
      smallVersion: true,
      // 图片
      base64: '',
      // 是否显示快照
      isSharePhotoShow: false,
      // 图片
      shareCirleUrl: '',
      // qrcode
      qrCode: '',
      // 分享的弹层
      popOptions: {
        visible: false
      },
      // 页面已经滚动
      isScroll: false,
      // 本站以外的通用loading
      isLoading: false,
      fId: Number(this.$route.query.fId),
      // 进入页面时的timestamp
      pageInitTimeStamp: '',
      clientId: '',
      isTujiaHarmony: false,
      tujiaHarmonyStyle: {}
    }
  },
  async created() {
    this.platform = await this.getEnv()
    const query = this.$route.query
    let id = query.id
    if (!window.nostorage) {
      if (id) {
        localStorage.setItem('id', id)
      } else {
        id = localStorage.getItem('id')
      }
    }
    this.$root.promotionId = id
    if (process.env.VUE_APP_LOCAL !== 'Q' && process.env.VUE_APP_LOCAL !== 'C') {
      if (process.env.VUE_APP_LOCAL !== 'M') {
        const appInit = require('@/utils/tj_app_init').default
        await appInit(query)
      } else {
        if (this.platform === 2) {
          // 蚂蚁APP
          const mayiAppInit = require('@/utils/mayiAppInit').default
          mayiAppInit(query)
        } else if (this.platform === 1 && this.tjChannelId === 'tujia') {
          // 蚂蚁小程序
          const mayiAppInit = require('@/utils/mayiAppInit').default
          mayiAppInit(query)
        }
        if (this.platform === -1 || this.platform === 4) {
          // 浏览器环境存储蚂蚁用户信息
          let ticket = ''
          if (window.location.href.indexOf('fvt') > 0) {
            ticket = Cookies.get('fvtwebticket')
            Cookies.set(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserToken`, ticket, {
              domain: process.env.VUE_APP_MAYI_DOMAIN,
              expires: 7
            })
          } else {
            ticket = Cookies.get('onlinewebticket')
            Cookies.set(`${process.env.VUE_APP_MAYI_DOMAIN}_PortalContext_UserToken`, ticket, 7)
          }
        }
      }
      this.$root.query = query
      this.$root.atm_source = query.atm_source
      try {
        // const config = process.env.VUE_APP_LOCAL !== 'M' ? (await getUserInfo()) : (await getUserInfoForMayi())
        const config = process.env.VUE_APP_LOCAL !== 'M' ? { data: { userInfo: this.userInfo } } : (await getUserInfoForMayi())
        if (config.data && config.data.userInfo) {
          this.$root.isLogin = true
          this.$root.isOldUser = config.data.userInfo.oldUser
        }
      } catch (e) {
        errorReport(e)
      }
    } else if (process.env.VUE_APP_LOCAL === 'Q' || isQunarApp) {
      // 去哪儿钩子  用户信息 新老客等等
      qunarHook()
      // 页面pv
      recordPv({ curPage: `cms_${this.$route.query.id}` })
      // Q端取新老客
      try {
        const userType = await this.getUserType()
        this.$root.isOldUser = userType === 1
      } catch (err) {
        this.$root.isOldUser = false
      }
    } else if (process.env.VUE_APP_LOCAL === 'C') { // C端取新老客
      const config = { data: { userInfo: this.userInfo } }
      if (config.data && config.data.userInfo) {
        this.$root.isLogin = true
        this.$root.isOldUser = config.data.userInfo.oldUser
      }
    }
    if (process.env.VUE_APP_LOCAL === 'M') {
      // 用于当为蚂蚁环境时,不显示网页分享
      this.$root.isMayi = true
    }
    // eslint-disable-next-line
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', this.checkWxReady, false)
    }
    // 查询阿波罗配置
    try {
      await this.getApolloConfig()
    } catch (error) {}
    await this.getHarmonyInfo()

    await this.initPromotion(id)

    if (process.env.VUE_APP_LOCAL !== 'Q' && process.env.VUE_APP_LOCAL !== 'C') {
      this.TJShare = require('@tujia/fe_js_com/src/business/tjShare/TJShare.js').default
      this.tjShare = this.TJShare.getInstance()
      const This = this
      this.tjShare.getPlatformType((env) => {
        if (env === this.TJShare.platformTypes.WX_ENV) {
          This.platformShare({ isNeedWxTip: false, wxTimeLineImgUrl: null, appWxType: 1, platformEnv: env })
        }
      })
    }
    // 获取版本号
    this._getSmallAppVersion()
  },
  destroyed() {
    document.removeEventListener('WeixinJSBridgeReady', this.checkWxReady, false)
  },
  async mounted() {
    // 此处临时修复某些IOS浏览器从其他H5页面返回时，页面出现异常透明弹层的问题
    document.addEventListener('scroll', () => { this.isScroll = true })
    window.addEventListener('beforeunload', this.reportLeavingPage)
    let intervalScroll = window.setInterval(() => {
      if (!this.isScroll) {
        window.scroll(0, 0)
      } else {
        clearInterval(intervalScroll)
      }
    }, 200)
    setTimeout(() => {
      if (intervalScroll) {
        clearInterval(intervalScroll)
      }
    }, 3000)
    //  埋点上报
    getClientId((cid) => {
      this.pageInitTimeStamp = new Date().getTime()
      this.clientId = cid
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_EXPOSURE',
        ext: {
          timeStamp: this.pageInitTimeStamp,
          urlPath: window?.location?.href || this.$route?.fullPath,
          clientId: this.clientId,
          rank_list_id: this.$route?.query?.id
        }
      })
    })
    // 手动上报pv
    if (process.env.VUE_APP_LOCAL === 'Q') {
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_PAGEVIEW_WITH_USERINFO',
        ext: {
          rank_list_id: this.$route?.query?.id,
          userid: Sniff.uinfo?.uid || ''
        }
      })
    } else {
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_PAGEVIEW_WITH_USERINFO',
        ext: {
          rank_list_id: this.$route?.query?.id,
          userid: tjCookie.getUserId() || ''
        }
      })
    }

    this.$nextTick(() => {
      if (['T20220602105145', 'T20220603173948'].indexOf(this.$route.query.id) > -1) {
        document.body.onclick = () => {
          callApp({
            ios: 'tujia://home?index=2',
            ios9Plus: `https://app.tujia.com/go/home?index=2&app_store_url=${encodeURIComponent('https://itunes.apple.com/app/id582934943?mt=8')}`,
            android: 'tujia://home?index=2',
            wxDownUrl: '',
            iosDownloadUrl: 'https://itunes.apple.com/app/id582934943?mt=8',
            androidDownloadUrl: 'market://details?id=com.tujia.hotel',
            uniformDownloadUrl: ''
          })()
        }
      }
    })
    // 小红书调取信息回传接口
    this.xhsexposure()
    this.getHouseInfo()
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.reportLeavingPage)
    window.removeEventListener('pageshow', this._onPageShow)
  },
  methods: {
    /**
     * 获取房屋信息
     * 根据路由参数中的houseId或exclusiveHouse获取房屋详情
     */
    async getHouseInfo() {
      try {
        // 从路由参数中获取房屋ID
        const { houseId, exclusiveHouse } = this.$route.query
        // 如果存在houseId或exclusiveHouse参数
        if (houseId || exclusiveHouse) {
          let houseIdList = []
          // 将houseId或exclusiveHouse加入查询列表
          if (houseId) {
            houseIdList = [houseId]
          } else if (exclusiveHouse) {
            houseIdList = getExclusiveHouse(exclusiveHouse)
          }
          // 调用接口获取房屋详情
          const houseRes = await fetchHouseDetail({ houseIdList })
          console.log(houseRes)
          // 将获取到的房屋信息赋值给houseInfo
          this.houseInfo = houseRes?.data?.items?.length ? houseRes.data.items[0] : null
        }
      } catch (e) {
        // 捕获并打印异常
        console.log(e)
      }
    },
    /**
     * 点击关闭快照
     */
    sharePhotoHide() {
      this.$eventBus.$emit('closePhoto', true)
      this.isSharePhotoShow = false
    },
    /**
     * 初始化活动
     * @param {Object} info 从接口返回的数据部分
     */
    async initPromotion(id, redirect = true) {
      let ret = null
      let isError = false

      try {
        if (this.$route.query.isPreview) {
          this.$root.isPreview = true
          ret = process.env.VUE_APP_LOCAL === 'M' ? (await getPromotionPreviewForMayi(id)) : (await getPromotionPreview(id))
        } else {
          if (process.env.VUE_APP_LOCAL === 'M') {
            ret = await getPromotionDetailForMayi(id)
          } else {
            // qunar的初始化活动详情请求
            if (process.env.VUE_APP_LOCAL === 'Q') {
              ret = await getPromotionDetailForQ(id)
            } else {
              ret = await getPromotionDetail(id)
            }
          }
          // ret = process.env.VUE_APP_LOCAL === 'M' ? (await getPromotionDetailForMayi(id)) : (await getPromotionDetail(id))
        }

        if (ret && ret.errcode === 0) {
          this.$root.serviceTime = ret.data.serviceTime
          const info = ret.data
          if (info) {
            this.promotion = info
            let promotionInfo = info.data && JSON.parse(info.data.data || '{}')
            console.log(promotionInfo)
            // 渠道2-H5
            // eslint-disable-next-line eqeqeq
            this.$root.isMobile = promotionInfo.channel == '2'
            // 强制登录
            this.$root.isForceLogin = promotionInfo.data.isForceLogin
            if (this.$root.isForceLogin && process.env.VUE_APP_LOCAL !== 'Q' && !(await this.isLogin())) {
              const { autoGetRedpacketId, fId } = this.$route.query
              const redirect = `${window.location.href}${autoGetRedpacketId ? '&autoGetRedpacketId=' + autoGetRedpacketId : ''}${fId ? '&fId=' + fId : ''}`
              this.goLoginPage({ redirect })
            } else if (this.$root.isForceLogin && process.env.VUE_APP_LOCAL === 'Q') {
              loginQ()
            }
            // // 新老客弹窗
            // // 判断是否有登录信息，登录之后才弹一次
            if (this.isActiveFission) {
              if ((process.env.VUE_APP_LOCAL !== 'Q') && (await this.isLogin())) {
                this.toastHandler(promotionInfo)
              } else if (process.env.VUE_APP_LOCAL === 'Q' && Sniff.isLogin) {
                this.toastHandler(promotionInfo)
              }
            }

            // 领取体验红包
            const cmsExperienceMemberVo = info?.cmsExperienceMemberVo
            if (cmsExperienceMemberVo?.canAcquire) {
              if (process.env.VUE_APP_LOCAL === 'Q' || isQunarApp) {
                this._receiveExperienceMemberForQ(cmsExperienceMemberVo?.scene)
              } else {
                this._receiveExperienceMember(cmsExperienceMemberVo?.scene)
              }
            }
            // debugger
            document.title = promotionInfo.data.htmlTitle
            // 统一途家蚂蚁去哪儿title
            this.title = promotionInfo.data.htmlTitle
            if (process.env.VUE_APP_LOCAL !== 'Q') {
              this.setTitleHack(this.title)
            }
            // 统一途家蚂蚁去哪儿活动规则逻辑
            this.rules = promotionInfo.data.rules
            this.rulesImg = promotionInfo.data.rulesImg
            this.rulePlacement = promotionInfo.data.rulePlacement
            if (process.env.VUE_APP_LOCAL === 'Q' || isQunarApp) {
              // 去哪儿app内原生导航栏设置
              // eslint-disable-next-line
              QConfig()
            }
            document.body.style.backgroundColor = promotionInfo.data.backgroundColor
            document.body.style.backgroundImage = promotionInfo.data.backgroundImageUrl ? `url(${this.picHost}${promotionInfo.data.backgroundImageUrl})` : ''
            document.body.style.backgroundSize = '100%'
            document.body.style.backgroundRepeat = 'no-repeat'

            // 鸿蒙系统适配底部安全区域
            if (Sniff.isHarmonyWithoutAdr || this.isTujiaHarmony) {
              const safeAreaBottomHeight = Sniff.isHarmonyWithoutAdr ? Sniff.safeAreaBottomHeight || 0 : this.tujiaHarmonyStyle.bottom
              document.body.style.paddingBottom = safeAreaBottomHeight + 'px'
              let stateBarElement = document.createElement('div')
              stateBarElement.id = 'mockSafeAreaBottom'
              stateBarElement.style.width = '100%'
              stateBarElement.style.height = `${safeAreaBottomHeight}px`
              stateBarElement.style.position = 'fixed'
              stateBarElement.style.background = '#fff'
              stateBarElement.style.bottom = '0'
              stateBarElement.style.zIndex = '999'
              document.body.appendChild(stateBarElement)
            }

            // 这是一个很蠢的方案，但是暂时没办法。2期的时候会通过产品库需求改变。暂时就蠢一下吧
            const importType = promotionInfo.data.importType || 0
            const sqlName = promotionInfo.data.sqlName || ''
            if (importType === 1) {
              const houseData = await getHouseGroup(sqlName)
              const houseAllList = houseData ? houseData.data || [] : []
              this.$root.tmpHouseList = this.analysisList(houseAllList)
            } else {
              this.$root.tmpHouseList = promotionInfo.houseList
            }
            this.$root.activityInfo = info.data || {}
            this.$root.htmlTitle = promotionInfo.data.htmlTitle
            this.children = promotionInfo.data.children
            this.channel = promotionInfo.channel
            this.$root.channel = promotionInfo.channel
            this.entryInfo = {
              needShowEntry: promotionInfo.data.privateProps.needShowEntry,
              info: promotionInfo.data.privateProps.entry
            }
            const queryObjs = urlHelper.queryStrings()
            const queryObjsForShare = {}
            queryObjsForShare.id = queryObjs.id
            if (queryObjs.code || queryObjs.fromForLog) {
              queryObjsForShare.code = queryObjs.code || queryObjs.fromForLog
            }
            queryObjsForShare.tjchannelid = this.tjChannelId
            // queryObjsForShare.reloadfix = ''
            if (queryObjs.hasOwnProperty('fixqr')) {
              queryObjsForShare.fixqr = '1'
            }
            // 专属房源
            if (queryObjs.exclusiveHouse) {
              queryObjsForShare.exclusiveHouse = queryObjs.exclusiveHouse
            }
            if (this.isActiveFission) {
              if (process.env.VUE_APP_LOCAL !== 'Q') {
                queryObjsForShare.fId = tjCookie.getUserId() || ''
              } else if (process.env.VUE_APP_LOCAL === 'Q') {
                queryObjsForShare.fId = (Sniff.uinfo && Sniff.uinfo.uid) || ''
              }
            }
            this.share = {
              isShowShareIcon: (promotionInfo.data && promotionInfo.data.privateProps && promotionInfo.data.privateProps.needShareToWechat) || false,
              weShare: promotionInfo.data.privateProps.needShareToWechat ? promotionInfo.data.privateProps.shareSetting : null,
              normalShare: {
                shareTitle: promotionInfo.data.shareTitle,
                shareDescription: promotionInfo.data.shareDescription,
                shareImg: promotionInfo.data.shareImg
              },
              link: window.location.origin + window.location.pathname + '?' + urlHelper.getStringByObject(queryObjsForShare)
            }
            // 提前画图
            // if (this.share.isShowShareIcon) {
            //   this._advanceDrawing()
            // }
            // 订单氛围的逻辑
            if (promotionInfo.data.privateProps.needShowOrder) {
              this.needShowOrder = true
              this.atmosphereConfig = promotionInfo.data.privateProps.order
            }
            if (!window.nostorage) {
              // this.$root.promotionId = localStorage.getItem('id')
              this.$root.promotionId = id
            }
            // 分享参数，添加变量尽量通过参数修改，不要在方法内部处理
            initPageShare({
              title: this.share.weShare?.shareTitle || this.share.normalShare.shareTitle, // 分享标题
              desc: this.share.normalShare.shareDescription, // 分享描述
              link: this.share.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
              imageUrl: this.picHost + (this.share.weShare?.shareSceneSession || this.share.normalShare.shareImg), // 分享图标
              timelineImg: this.picHost + (this.share.weShare?.shareSceneTimeline || this.share.normalShare.shareImg),
              goLink: this.share.weShare?.goLink || ''
            })
          }
        } else if (ret.errcode === 404 && redirect) {
          if (process.env.VUE_APP_LOCAL === 'Q' || isQunarApp) {
            const fromForLog = getFromForLog()
            this.$router.replace(`/modules/defaulterror?fromForLog=${fromForLog}`)
            return
          }
          this.$router.replace('/modules/defaulterror')
        } else {
          isError = true
        }
      } catch (e) {
        console.error(e)
        errorReport(e)
      }
      if (isError) {
        this.msg = '活动信息加载失败！'
        this.showToast = true
        errorReport(ret)
      }
    },
    analysisList(List) {
      let map = {}
      for (let i = 0; i < List.length; i++) {
        const obj = List[i]
        const allLabelList = obj.house_label ? obj.house_label.split(' ') : []
        const labelList = allLabelList.filter((item) => item && item.trim())
        const objNew = {
          house_group: obj.house_group,
          id: obj.house_id,
          comment: obj.house_description,
          labels: labelList
        }
        if (!map.hasOwnProperty(obj.house_group)) {
          map[obj.house_group] = [objNew]
        } else {
          map[obj.house_group].push({ ...objNew })
        }
      }
      return map
    },
    async getUserType() {
      const userType = getSession(sessionKeys.IS_OLD_USER)
      if (userType) {
        return userType
      }
      await checkUser()
      return getSession(sessionKeys.IS_OLD_USER)
    },
    toastHandler(promotionInfo) {
      if (!window.localStorage.getItem('isFirstOrderUserToast')) {
        if (promotionInfo.data.isOrderUserToast && this.$root.isOldUser) {
          ToastUI('邀请一位新用户成单可得9折优惠券')
          window.localStorage.setItem('isFirstOrderUserToast', 1)
        } else if (promotionInfo.data.isOrderUserToast && !this.$root.isOldUser && !this.isSharedPeople) {
          ToastUI('邀请一位用户参与活动可得9折优惠券')
          window.localStorage.setItem('isFirstOrderUserToast', 1)
        } else if (promotionInfo.data.isOrderUserToast && !this.$root.isOldUser && this.isSharedPeople) {
          ToastUI('好友送您一张9折优惠券，快去看看吧')
          window.localStorage.setItem('isFirstOrderUserToast', 1)
        }
      }
    },
    rulesHandle(state) {
      this.showRules = state
    },
    /**
     *
     * 解决在某些情况下设置title不生效
     */
    setTitleHack(title) {
      const u = navigator.userAgent
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (this.platform === 8 && isIos) {
        this.checkAliSDKReady(() => {
          // eslint-disable-next-line no-undef
          AlipayJSBridge.call('setTitle', {
            title: this.title
          })
        })
      }
      // 途家ios平台 设置title
      if (this.platform === 2 && isIos) {
        try {
          require('@lib/business/tjBridge/WebViewJavascriptBridge.js')
          window.bridge && window.bridge.setTitle(title)
        } catch (error) {
          console.log(error)
        }
      }
    },
    /**
     *
     * 检查支付宝sdk是否加载完毕
     */
    checkAliSDKReady(callback) {
      // 如果jsbridge已经注入则直接调用
      if (window.AlipayJSBridge) {
        callback && callback()
      } else {
        // 如果没有注入则监听注入的事件
        document.addEventListener('AlipayJSBridgeReady', callback, false)
      }
    },
    /**
     * 校验版本号
     * @returns {Boolean} 返回值描述
     */
    _getSmallAppVersion() {
      this.smallVersion = tjAppHelper.getAppVersion() < 7.2
    },
    /**
     * 领取体验会员
     */
    _receiveExperienceMember(scene = '') {
      const promotionInfo = this.promotion?.data && JSON.parse(this.promotion.data.data || '{}')
      let toastText = ''
      let status = 0
      experienceMemberAPI.receiveExMember({ scene }).then((data) => {
        status = data?.isSuccess ? 1 : 2
        toastText = data?.isSuccess ? '已为您升级最高等级会员，过期后可来本页面再次领取' : '网络繁忙，请重试'
      })
        .catch((err) => {
          toastText = '网络繁忙，请重试'
          status = 2
          console.log('🚀 ~ file: index.vue ~ line 553 ~ _receiveExperienceMember ~ err', err)
        })
        .finally(() => {
          window._fas && window._fas.setCustomTrack({
            eventname: 'C_HOME_CMS_TOAST_EXPOSURE',
            ext: {
              rank_list_id: this.$route?.query?.id,
              rank_list_name: promotionInfo?.data?.htmlTitle,
              text: toastText,
              // 1 成功 2失败
              status: status
            }
          })
          ToastUI(toastText)
        })
    },
    _receiveExperienceMemberForQ(scene = '') {
      const promotionInfo = this.promotion?.data && JSON.parse(this.promotion.data.data || '{}')
      let toastText = ''
      let status = 0
      receiveExMemberForQ(scene).then((data) => {
        status = data?.value?.ret ? 1 : 2
        toastText = data?.value?.ret ? '已为您升级最高等级会员，过期后可来本页面再次领取' : '网络繁忙，请重试'
      })
        .catch((err) => {
          toastText = '网络繁忙，请重试'
          status = 2
          console.log('🚀 ~ file: index.vue ~ line 553 ~ _receiveExperienceMember ~ err', err)
        })
        .finally(() => {
          window._fas && window._fas.setCustomTrack({
            eventname: 'C_HOME_CMS_TOAST_EXPOSURE',
            ext: {
              rank_list_id: this.$route?.query?.id,
              rank_list_name: promotionInfo?.data?.htmlTitle,
              text: toastText,
              // 1 成功 2失败
              status: status
            }
          })
          ToastUI(toastText)
        })
    },
    xhsexposure() {
      const outcode = tjCookie.getOutcode() || ''
      const isReg = /^tujia_xhs_/
      if (outcode && isReg.test(outcode) && process.env.VUE_APP_LOCAL === 'T') {
        redBookiApi.xhsexposure({
          eventType: 124,
          clickId: outcode
        })
          .then((res) => {})
          .catch(({ errorMsg }) => {})
      }
    },
    async getApolloConfig() {
      try {
        const ret = await commonApi.getApolloConfig({
          multiple: [{
            nameSpace: 'fe-config',
            keys: ['isFetchHouseNewForCMS']
          }]
        })
        this.$root.isFetchHouseNewForCMS = ret?.data?.['fe-config']?.isFetchHouseNewForCMS || false
      } catch (error) {}
    },
    async getHarmonyInfo() {
      const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (this.tujiaAppCpd && !isIos) {
        try {
          const appInfo = await getAppInfo()
          // 华为鸿蒙OS
          this.isTujiaHarmony = String(appInfo.devType) === '5'
          if (this.isTujiaHarmony) {
            const styleInfo = await getHarmonyOSImmersive()
            this.tujiaHarmonyStyle = {
              top: Number(styleInfo.top),
              bottom: Number(styleInfo.bottom)
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    },
    /**
     * 上报离开页面
     */
    reportLeavingPage() {
      // 阻止默认行为（例如，显示一个对话框）
      // e.preventDefault()
      const nowTimeStamp = new Date().getTime()
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_EXPOSURE',
        ext: {
          timeStamp: nowTimeStamp,
          duration: Math.ceil(nowTimeStamp - this.pageInitTimeStamp) / 1000,
          clientId: this.clientId,
          urlPath: window?.location?.href || this.$route?.fullPath,
          rank_list_id: this.$route?.query?.id
        }
      })
      window._fas && window._fas.sendLogsNow()
      window.removeEventListener('beforeunload', this.reportLeavingPage)
    }
  }
}
</script>
<style lang='scss'>
.promotion-wrap {
  position: relative;
  // overflow: auto;
  strong {
    font-weight: bold;
  }

  &.pc-wrap {
    section {
      margin: auto;
      max-width: 1190px;
    }
    section[padding='1'] {
      max-width: 100%;
      section {
        max-width: 100%;
      }
    }

    .single-col,
    .double-col,
    .swiper-col,
    .single-comment-col {
      > div {
        display: flex;
        flex-wrap: wrap;
        .house-warp {
          width: 33%;
          padding: 0.6666rem 0.5rem;
          box-sizing: border-box;
          margin: 0;
        }
      }
      .atmosphere-icon {
        height: 28px;
      }
    }
  }
  .common-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.tabPage {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  flex-direction: column;
  z-index: 9999;
  background: #f8f8f8;
  img {
    width: 100%;
  }
}
</style>
